import { createFileRoute } from "@tanstack/react-router";
import { BygherreraadgivningPage, bygherreraadgivningHead } from "@/pages/BygherreraadgivningPage";

export const Route = createFileRoute("/bygherreraadgivning")({
  head: () => bygherreraadgivningHead("da"),
  component: () => <BygherreraadgivningPage locale="da" />,
});
